import { render, staticRenderFns } from "./Brokers.container.vue?vue&type=template&id=586c0bea&scoped=true&"
import script from "./Brokers.container.vue?vue&type=script&lang=js&"
export * from "./Brokers.container.vue?vue&type=script&lang=js&"
import style0 from "./Brokers.container.vue?vue&type=style&index=0&id=586c0bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c0bea",
  null
  
)

export default component.exports